import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get credits List of products available for subscrition
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditproducts
*/
export const requestproductsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'credit/products',
		isCancellable: true
	})
}

/** Gets plafonds for a credit product
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditproducts%7Bpid%7Dsubproduct%7Bspid%7Dplafond
*/
export const requestProductPlafond = payload => {
	return httpClient({
		method: 'GET',
		url: `credit/products/${payload.pid}/subproduct/${payload.spid}/plafond`,
        params: payload.params,
		isCancellable: true
	})
}

/** Create a credit account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditproducts%7Bpid%7Dsubproduct%7Bspid%7Dacquire
*/
export const createCreditAccount = payload => {
	return httpClient({
		method: 'POST',
		url: `credit/products/${payload.pid}/subproduct/${payload.spid}/acquire`,
		data: payload.data,
		operationTypeId: '25003' /* for mocks handling of tokens */
	})
}

/** Amortize a credit account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditaccounts%7BaccountToAmortizeId%7Dsettlement
*/
export const amortizeCreditAccount = payload => {
	return httpClient({
		method: 'POST',
		url: `credit/accounts/${payload.accountToAmortizeId}/settlement`,
		data: payload.data,
		operationTypeId: '25004' /* for mocks handling of tokens */
	})
}

/** Partial Amortization of credit account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditaccounts%7BaccountToAmortizeId%7DpartialSettlement
*/
export const partialAmortizeCreditAccount = payload => {
	return httpClient({
		method: 'POST',
		url: `credit/accounts/${payload.accountToAmortizeId}/partialSettlement`,
		data: payload.data,
		operationTypeId: '25004' /* for mocks handling of tokens */
	})
}

/** Checks if the credit that the person picked is available for his clientApp
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditproduct%7Bpid%7DvalidateBlacklist
*/
export const validateBlackList = payload => {
	return httpClient({
		method: 'GET',
		url: `credit/product/${payload.pid}/validateBlacklist`,
        params: payload.params
	})
}

/** Gets client financial information
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditfinancialInformation
*/
export const requestFinancialInformation = payload => {
	return httpClient({
		method: 'GET',
		url: 'credit/financialInformation',
        params: payload,
		isCancellable: true
	})
}

/** Request Credit Simulation
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditexternalsimulation
*/
export const requestCreditSimulation = payload => {
	return httpClient({
		method: 'POST',
		url: 'credit/external/simulation',
        data: payload,
		isCancellable: true
	})
}

/** Download Financial Plan
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditexternalfinancialPlan
*/
export const downloadFinancialPlan = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'credit/external/financialPlan',
		params: payload.params
	})
}

/** Sends Financial Plan by email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditexternalfinancialPlanemail
*/
export const sendFinancialInformationByEmail = payload => {
	return httpClient({
		method: 'GET',
		url: 'credit/external/financialPlan/email',
        params: payload.params
	})
}

/** Download Simulation
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditsimulationdocumentexport
*/
export const downloadSimulation = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'credit/simulation/document/export',
        params: payload.params
	})
}

/** Submit Simulation and create credit
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditexternalsubmit
*/
export const submitSimulationAndCreateCredit = payload => {
	return httpClient({
		method: 'POST',
		url: 'credit/external/submit',
		params: payload,
		operationTypeId: '25005' /* for mocks handling of tokens */
	})
}

/** Download Credit Contract
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditsubscriptioncontractDocument
*/
export const downloadCreditContract = payload => {
    return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'credit/subscription/contractDocument',
		params: payload.params
	})
}

/** Sends Financial Plan to User Email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditexternalfinancialPlanemail
*/
export const sendFinancialPlanEmail = payload => {
	return httpClient({
		method: 'GET',
		url: 'credit/external/financialPlan/email',
		params: { ...payload.params, ...payload.data }
	})
}

/** Get Credit Products Operation Type
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditproducts
*/
export const getCreditProductsOperation = payload => {
	return httpClient({
		method: 'GET',
		url: 'credit/products',
		params: payload
	})
}
/** Get Credit Simulation info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditsimulationgeneric
*/
export const getCreditSimulationinfo = payload => {
	return httpClient({
		method: 'GET',
		url: 'credit/simulation/generic',
		params: payload
	})
}

/** Sends Financial Plan to User Email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditsimulationgenericemail
*/
export const sendSimulationEmail = payload => {
	return httpClient({
		method: 'GET',
		url: 'credit/simulation/generic/email',
		params: {
			...payload,
			...payload.data
		}
	})
}

/** Download Simulation Info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditsimulationgenericexport
*/
export const downloadSimulationInfo = payload => {
    return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'credit/simulation/generic/export',
		params: payload
	})
}
